
import React, { Component } from "react";
import Config from "../../../config";
import { message,Modal, Button, Select, Input, Radio, Checkbox } from "antd";
import { tsDateToThaiDate } from "../../../utils/func";

const CheckboxGroup = Checkbox.Group;
const RadioGroup = Radio.Group;
const Option = Select.Option;
const TextArea = Input.TextArea;

const ListDisable = [
  { STEP_C: "1", SEQ: "0100", data: [], 2: ["ก.1"], 3: ["ข.1"] },
  { STEP_C: "1", SEQ: "0200", data: ["3"], 2: ["ก.1"], 3: [] },
  { STEP_C: "1", SEQ: "0300", data: ["2"], 2: [], 3: ["ข.2"] },
  { STEP_C: "1", SEQ: "0400", data: [], 2: ["ก.7"], 3: ["ข.4"] },
  { STEP_C: "1", SEQ: "0500", data: ["1", "2", "3"], 2: [], 3: [] },

  { STEP_C: "2", SEQ: "0100", data: [], 2: ["ก.2"], 3: ["ข.2"] },
  { STEP_C: "2", SEQ: "0200", data: ["2"], 2: [], 3: [] },

  { STEP_C: "3", SEQ: "0100", data: [], 2: ["ก.3"], 3: ["ข.1"] },
  { STEP_C: "3", SEQ: "0200", data: [], 2: ["ก.3"], 3: ["ข.2"] },
  { STEP_C: "3", SEQ: "0300", data: [], 2: ["ก.7"], 3: ["ข.4"] },
  { STEP_C: "3", SEQ: "0400", data: ["2", "3"], 2: [], 3: [] },

  { STEP_C: "4", SEQ: "0100", data: ["3"], 2: ["ก.3"], 3: [] },
  { STEP_C: "4", SEQ: "0200", data: ["2"], 2: [], 3: ["ข.2"] },
  { STEP_C: "4", SEQ: "0300", data: ["2"], 2: [], 3: ["ข.2", "ข.3"] },
  { STEP_C: "4", SEQ: "0400", data: ["2"], 2: [], 3: ["ข.2", "ข.3"] },
  { STEP_C: "4", SEQ: "0500", data: ["2"], 2: [], 3: ["ข.2", "ข.3"] },
  { STEP_C: "4", SEQ: "0600", data: ["2", "3"], 2: [], 3: [] },
  { STEP_C: "4", SEQ: "0700", data: ["2", "3"], 2: [], 3: [] },

  { STEP_C: "5", SEQ: "0100", data: ["3"], 2: [], 3: [] },
  { STEP_C: "5", SEQ: "0200", data: ["1", "2", "3"], 2: [], 3: [] },
  { STEP_C: "5", SEQ: "0300", data: ["1", "2", "3"], 2: [], 3: [] },
  { STEP_C: "5", SEQ: "0400", data: ["2"], 2: [], 3: ["ข.3"] },
  { STEP_C: "5", SEQ: "0500", data: ["2"], 2: [], 3: ["ข.3"] },
  { STEP_C: "5", SEQ: "0600", data: ["3"], 2: ["ก.3"], 3: [] },
  { STEP_C: "5", SEQ: "0700", data: [], 2: ["ก.7"], 3: ["ข.4"] },
  { STEP_C: "5", SEQ: "0800", data: ["2", "3"], 2: [], 3: [] },

  { STEP_C: "6", SEQ: "0100", data: ["3"], 2: ["ก.5"], 3: [] },
  { STEP_C: "6", SEQ: "0200", data: ["2", "3"], 2: [], 3: [] },
  { STEP_C: "6", SEQ: "0300", data: ["2", "3"], 2: [], 3: [] },
  { STEP_C: "6", SEQ: "0400", data: ["2"], 2: [], 3: ["ข.2", "ข.3"] },
  { STEP_C: "6", SEQ: "0500", data: ["2", "3"], 2: [], 3: [] },

  { STEP_C: "7", SEQ: "0100", data: ["3"], 2: ["ก.6"], 3: [] },
  { STEP_C: "7", SEQ: "0200", data: [], 2: ["ก.6", "ก.7"], 3: ["ข.1", "ข.4"] },
  { STEP_C: "7", SEQ: "0300", data: ["2"], 2: [], 3: ["ข.2"] },
  { STEP_C: "7", SEQ: "0400", data: ["2", "3"], 2: [], 3: [] },

    { STEP_C: "8", SEQ: "0100", data: [], 2: ["ก.6(1)", "ก.6(2)"], 3: ["ข.2"] },
  { STEP_C: "8", SEQ: "0200", data: ["1", "2", "3"], 2: [], 3: [] },
  { STEP_C: "8", SEQ: "0300", data: ["1", "2", "3"], 2: [], 3: [] },
  { STEP_C: "8", SEQ: "0400", data: ["1", "2", "3"], 2: [], 3: [] },
  { STEP_C: "8", SEQ: "0500", data: ["1", "2", "3"], 2: [], 3: [] }
];
console.log('m2', ListDisable)

class Xpage6ef04dc09 extends Component {
  constructor(props) {
    super(props);
      this.state = { ListDisable:ListDisable,modeLayout1 : false ,modeLayout2 : false,modeLayout3 : false  ,data1:[],data2:[],data3:{},visible2:false,visible3:false,m2:{}};
    let { year ,plt_bld_id } = this.props

    this.getDataLayoutAll(year ,plt_bld_id);
    //   this.getDisableList = this.getDisableList.bind(this);
  }

    getDataLayoutAll(year ,plt_bld_id){
        this.getDataLayout1(year ,plt_bld_id)
        this.getDataLayout2(year ,plt_bld_id)
        this.getDataLayout3(year ,plt_bld_id)
    }

    getDataLayout1(year ,plt_bld_id){
        let token = localStorage.getItem("ef_token");
        return fetch(Config.api + `/api/getReport-ef04dc09-l1?token=${token}&plt_bld_id=${plt_bld_id}&year=${year}`, {
            headers: {"Content-Type": "application/json",}
            }).then(response => response.json())
            .then(data => {
                if(data.resultCode ==20000 && data.data){
                    this.setState({ modeLayout1: 'view', data1: data.data ? data.data:[]});
                }
                console.log("getData1",data);
            }, err => {
            console.log("getData1", err);
        });
    }

    getDataLayout2(year ,plt_bld_id){
         let { step  } = this.props
        let token = localStorage.getItem("ef_token");
        return fetch(Config.api + `/api/getReport-ef04dc09-l2?token=${token}&plt_bld_id=${plt_bld_id}&year=${year}&step=${step}`, {
            headers: {"Content-Type": "application/json",}
            }).then(response => response.json())
            .then(data => {
                if(data.resultCode ==20000 && data.data && data.data.length > 0){
                    this.setState({modeLayout2:'view',data2:data.data});
                }
                console.log("getData2",data);
            }, err => {
            console.log("getData2", err);
        });
    }

    getDataLayout3(year ,plt_bld_id){
        let token = localStorage.getItem("ef_token");
        return fetch(Config.api + `/api/getReport-ef04dc09-l3?token=${token}&plt_bld_id=${plt_bld_id}&year=${year}`, {
            headers: {"Content-Type": "application/json",}
            }).then(response => response.json())
            .then(data => {
                if(data.resultCode ==20000 && data.data){
                    this.setState({modeLayout3:'view',data3:data.data[0]});
                }
                console.log("getData3",data);
            }, err => {
            console.log("getData3", err);
        });
    }

     putDataLayout2(){
         let { m2 } = this.state;
         let temp = this.getArrayDisable(m2.STEP_C, m2.SEQ);
         let v_l = false;
         if (temp && temp.length > 0) {
             temp = temp[0];
             let EXTRA_ARRAY = m2.EXTRA_ARRAY ? m2.EXTRA_ARRAY : []
             if (m2.PASS_FLAG === "2" || m2.PASS_FLAG === "3"){
                 if (temp[m2.PASS_FLAG] && temp[m2.PASS_FLAG].length >0) {
                     let t = temp[m2.PASS_FLAG].find(r => EXTRA_ARRAY.indexOf(r) > -1);
                     if (!t) {
                         v_l = true;
                         console.log(t)
                         message.error('กรุณาเลือกข้อมูลให้ครบ');
                     }
                 }
             }
         }
         if (v_l){
            return ;
         }

        let { step ,plt_bld_id, year,time } = this.props
        let token = localStorage.getItem("ef_token");
        
         m2.EXTRA = m2.EXTRA_ARRAY ? m2.EXTRA_ARRAY.reverse().join(",") : "";

        let data = {...m2, token,step ,plt_bld_id, year,time }
        console.log('data',data)
        return fetch(Config.api + `/api/putReport-ef04dc09-l2`, {
            method: 'PUT', // or 'PUT'
            body: JSON.stringify(data), // data can be `string` or {object}!
            headers:{
                'Content-Type': 'application/json'
            }
            }).then(response => response.json())
           .then((data)=>{
               console.log(data.resultCode)
                if(data.resultCode == 20000){
                    let { year ,plt_bld_id } = this.props
                    this.getDataLayout2(year ,plt_bld_id)
                    this.setState({visible2:false,m2:{}})
                }else{
                    alert('error')
                }
        },()=>{
              alert('error')
        });
    }

    Layout1(){
        let { data1, } = this.state
        let { year ,plt_bld_id } = this.props
        return <div>
                <h1>แบบกำหนดความรับผิดชอบในการตรวจสอบและรับรองการจัดการพลังงานตามข้อกำหนดวิธีการจดการพลังงานประจำปี {this.props.year}</h1>
                <table style={{borderSpacing:'1px 1px'}}>
                { data1.map((r)=>{
                    return <tbody>
                        <tr>
                            <td ><b>ชื่อนิติบุคคลที่ถูกตรวจสอบ : </b>{r.JURISTIC_NAME}<b>ประจำปี : </b>{year}<b>ครั้งที่ : </b></td>
                        </tr>
                        <tr>
                            <td ><b>ขื่อ{r.TYPE}."ควบคุม ที่ถูกตรวจสอบ : </b>{r.PLT_BLD_NAME}<b>TSIC-ID : </b>{r.TSIC_ID}<b>วันที่ : </b>{r.PROCEED_D}</td>
                        </tr>
                        <tr>
                            <td ><b>ชื่อผู้ตรวจสอบ : </b>{r.ORGANIZE_NAME}</td>
                        </tr>
                    </tbody>
                })
                    
                }
                </table>
                </div>
    }

    // getDisableList(STEP_C, SEQ){
        




    //     console.log(STEP_C, SEQ, ListDisable);
    // }

    getIsDisable(STEP_C, SEQ, col){
        return this.state.ListDisable.filter(r => r.STEP_C === STEP_C && r.SEQ === SEQ && r.data.indexOf(col) > -1).length > 0;
    }

    getArrayDisable(STEP_C, SEQ) {
        return this.state.ListDisable.filter(r => r.STEP_C === STEP_C && r.SEQ === SEQ);
    }


       Layout2(){
        let { data1,data2,data3,m2 } = this.state
        return <div>
                <table style={{borderSpacing:'1px 1px'}}>
                    {/* <tbody> */}
                        <tr>
                            <th rowSpan="3" style={{width:'350px',textAlign:'center'}}>รายการประเมิน</th>
                            <th colSpan="2" style={{textAlign:'center'}}>ผลการประเมิน</th>
                            <th colSpan="3" style={{textAlign:'center'}}>ความสอดคล้อง</th>
                            <th rowSpan="3" style={{textAlign:'center'}}>ข้อคิดเห็นการปรับปรังวิธีการดำเนินการจัดการพลังงาน</th>
                            <th rowSpan="3" style={{width:'85px',textAlign:'center'}}>&nbsp;</th>
                        </tr>
                        <tr>
                            <th rowSpan="2" style={{width:'200px',textAlign:'center'}}>ชื่อรายละเอียดของหลักฐานที่ตรวจพบ</th>
                            <th rowSpan="2" style={{width:'60px',textAlign:'center'}}>ไม่มี/ไม่ พบหลักฐาน</th>
                            <th rowSpan="2" style={{width:'60px',textAlign:'center'}}>สอดคล้อง กับข้อกำหนด</th>
                            <th colSpan="2" style={{width:'120px',textAlign:'center'}}>ไม่สอดคล้องกับข้อกำหนด</th>
                        </tr>
                        <tr>
                            <th style={{width:'60px',textAlign:'center'}}>ประเภท ร้ายแรง</th>
                            <th style={{width:'60px',textAlign:'center'}}>ประเภท ไม่ร้ายแรง</th>
                        </tr>
                        {
                            data2.map((r)=>{
                                let temp = this.getArrayDisable(r.STEP_C, r.SEQ);
                                let obj = {}
                                let mode = 1;
                                if (temp && temp.length > 0) {
                                    obj = temp[0];
                                    if (r.PASS_FLAG === '2' || r.PASS_FLAG ==='3')
                                    if (obj[r.PASS_FLAG].length > 0){
                                        mode = 2;
                                    }
                                }
                                return <tbody>
                                    {r.SEQ != m2.SEQ ? <tr style={{ display: r.SUB_STEP_DESC && r.SUB_STEP_DESC !== "" && r.SUB_STEP_DESC !== null ?'contents': 'none'}}>
                                    <td style={{width:'80px'}}> <div dangerouslySetInnerHTML={{__html:r.SUB_STEP_DESC}}/></td>
                                        <td>{r.EVIDENCE_DESC} </td>
                                    <td style={{textAlign:'center'}}>{r.EVIDENCE_FLAG && r.EVIDENCE_FLAG =='1'?<img src="images/icorrect.png"/>:null}</td>
                                        <td style={{ textAlign: 'center', backgroundColor: this.getIsDisable(r.STEP_C, r.SEQ, '1')?'#ddd':'#fff'}}>
                                            {r.PASS_FLAG == '1' ?<img src="images/icorrect.png"/>:null}
                                            {/* {r.PASS_FLAG == '1' ? <div>{r.EXTRA}</div>:null} */}
                                        </td>
                                        <td style={{ textAlign: 'center', backgroundColor: this.getIsDisable(r.STEP_C, r.SEQ, '2') ? '#ddd' : '#fff' }}>
                                            {r.PASS_FLAG == '2' && mode == 1?<img src="images/icorrect.png"/>:null}
                                            {r.PASS_FLAG == '2' && mode == 2? <div>{r.EXTRA}</div> : null}
                                        </td>
                                        <td style={{ textAlign: 'center', backgroundColor: this.getIsDisable(r.STEP_C, r.SEQ, '3') ? '#ddd' : '#fff' }}>
                                            {r.PASS_FLAG == '3' && mode == 1?<img src="images/icorrect.png"/>:null}
                                            {r.PASS_FLAG == '3' && mode == 2? <div>{r.EXTRA}</div> : null}
                                        </td>
                                    <td>{r.NOTE}</td>
                                    <td>
                                        
                                     {r.SUB_STEP_DESC && r.SUB_STEP_DESC !== "" && r.SUB_STEP_DESC !== null ?
                                        <div>
                                        <span style={{display:'block', textAlign:'right'}}>
                                        <ul className="myNavigation">
                                            <li><button type="button"  className="myButton1" style={{verticalAlign:'top',height:'32px'}}
                                             onClick={()=>{
                                                 this.setState({ visible2: true, m2: { ...r, EVIDENCE_FLAG: r.EVIDENCE_FLAG ? r.EVIDENCE_FLAG : '', EXTRA_ARRAY: r.EXTRA ? r.EXTRA.split(","):[] }})
                                                 }}>
                                                    <img src="images/iPencil.png"/>&nbsp;แก้ไข
                                                </button>
                                            </li>
                                        </ul>
                                        </span>
                                        </div>:null}
                                    </td>
                                </tr>
                                :<tr>
                                    <td style={{width:'80px'}}> <div dangerouslySetInnerHTML={{__html:r.SUB_STEP_DESC}}/></td>
                                    <td style={{textAlign:'center'}}  colSpan="6">
                                                 <div>{this.TRLayout2()} </div>
                                </td>
                                <td>
                                   {r.SUB_STEP_DESC && r.SUB_STEP_DESC !== "" && r.SUB_STEP_DESC !== null?
                                    <div>
                                    <Button key="back" onClick={() => { this.setState({ visible2: false, m2: {} }) }}>ปิด</Button>
                                    <Button key="submit" type="primary" loading={false}
                                        onClick={() => {
                                            this.putDataLayout2()
                                        }}>
                                        บันทึกข้อมูล
                                     </Button>
                                    </div>
                                    :null}
                               
                                </td>
                                </tr>
                                }
                                </tbody>
                            })
                        }
                        
                    {/* </tbody> */}
                </table>
                </div>
    }

        Layout3(){
        let { data1,data2,data3 } = this.state

            data3 = data3 ? data3:{}
        return <div>
                <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ขอรับรองว่าข้อความข้างต้นถูกต้อง เป็นจริงทุกประการ</div>
                <div>
                    <table className="MyStyle2">
                        <tbody>
                            <tr>
                                <td style={{width:'33%',textAlign:'center'}}> ลงชื่อ ........................................................................</td>
                                <td style={{textAlign:'center'}}>ลงชื่อ ........................................................................</td>
                                <td style={{width:'33%',textAlign:'center'}}>ลงชื่อ ........................................................................</td>
                            </tr>
                            <tr>
                                <td style={{width:'33%',textAlign:'center'}}>({data3.AUDIT_1})</td>
                                <td style={{textAlign:'center'}}>({data3.AUDIT_3})</td>
                                <td style={{width:'33%',textAlign:'center'}}>({data3.AUDIT_2})</td>
                            </tr>
                            <tr>
                                <td style={{width:'33%',textAlign:'center'}}>{data3.SIGN_1_D}</td>
                                <td style={{width:'33%',textAlign:'center'}}>{data3.SIGN_1_D}</td>
                                <td style={{width:'33%',textAlign:'center'}}>{data3.SIGN_1_D}</td>
                            </tr>
                        <tr>
                            <td style={{width:'33%',textAlign:'center'}}>(ผู้ชำนาญการ)</td>
                            <td style={{width:'33%',textAlign:'center'}}>(ผู้ช่วยผู้ชำนาญการ)</td>
                            <td style={{width:'33%',textAlign:'center'}}>(ผู้ช่วยผู้ชำนาญการ)</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    }

        MDLayout2(){
        let { data1,data2 ,visible2,m2 } = this.state

        let select = [{value:'1',text:'สอดคล้อง'},{value:'2',text:'ไม่สอดคล้อง (ร้ายแรง)'},{value:'3',text:'ไม่สอดคล้อง (ไม่ร้ายแรง)'}]
        let radio = [{value:'1',text:'มี'},{value:'',text:'ไม่มี/ไม่พบ'},]
        return <div>
               <Modal
                visible={visible2}
                title="บันทึกข้อมูลการตรวจสอบการจัดการพลังงาน"
                onOk={()=>{}}
                onCancel={()=>{this.setState({visible2:false,m2:{}})}}
                footer={[
                    <Button key="back" onClick={()=>{this.setState({visible2:false})}}>ปิด</Button>,
                    <Button key="submit" type="primary" loading={false} onClick={()=>{
                        this.putDataLayout2()
                    }}>
                    บันทึกข้อมูล
                    </Button>,
                ]}
                >
               
               <div>
                        <form >
                            <table>
                                <tr>
                                    <td>สถานะหลักฐานที่ตรวจพบ</td>
                                    <td>
                                      <RadioGroup onChange={(e)=>{
                                            console.log(e)
                                            let { m2 } =  this.state;
                                            m2.EVIDENCE_FLAG = e.target.value
                                            this.setState({m2:m2})
                                        }} value={m2.EVIDENCE_FLAG}>
                                        {
                                            radio.map((r)=>{
                                                return <Radio value={r.value}>{r.text}</Radio>
                                            })
                                        }
                                    </RadioGroup>
                                    </td>
                                </tr>				
                                <tr>
                                    <td>หลักฐานที่ตรวจพบ</td><td>
                                      <Input  name="EVIDENCE_DESC" value={m2.EVIDENCE_DESC} size="80" maxlength="500"
                                      onChange={(e)=>{
                                            console.log(e)
                                            let { m2 } =  this.state;
                                            m2.EVIDENCE_DESC = e.target.value
                                            this.setState({m2:m2})
                                        }}
                                       style={{width: '200px'}}/>
                                    </td>
                                </tr>
                                <tr>
                                    <td>ความครบถ้วนถูกต้อง</td><td>
                                        <Select name="PASS_FLAG" className="" onChange={(e)=>{
                                             console.log(e)
                                            let { m2 } =  this.state;
                                            m2.PASS_FLAG = e
                                            this.setState({m2:m2})
                                        }} defaultValue=""  value={m2.PASS_FLAG}>
                                        <Option value="">----กรุณาเลือก----</Option>
                                        {
                                            select.map((r)=>{
                                                return <Option value={r.value}>{r.text}</Option>
                                            })
                                        }
                                        </Select>

                                    </td>
                                </tr>
                                <tr>
                                    <td>ข้อคิดเห็นการปรับปรุงวิธีการดำเนินการจัดการพลังงาน</td>
                                    <td>
                                     <TextArea  name="NOTE" value={m2.NOTE} size="80" maxlength="500"
                                      onChange={(e)=>{
                                            console.log(e)
                                            let { m2 } =  this.state;
                                            m2.NOTE = e.target.value
                                            this.setState({m2:m2})
                                        }}
                                       style={{width: '200px'}}/>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan='2' align='right'>
                &nbsp;
                                    </td>
                                </tr>
                            </table>
                           
                        </form>
                    </div>

                </Modal>
            </div>
    }

    TRLayout2(){
        let { data1,data2 ,visible2,m2 } = this.state
        let c2 = [];
        let c3 = [];
        let select = [
            {value:'1',text:'สอดคล้อง'},
            {value:'2',text:'ไม่สอดคล้อง (ร้ายแรง)'},
            {value:'3',text:'ไม่สอดคล้อง (ไม่ร้ายแรง)'}
        ]
        let temp = this.getArrayDisable(m2.STEP_C, m2.SEQ);
        if (temp && temp.length >0) {
            temp = temp[0];
            select = select.filter(r => temp.data.indexOf(r.value)===-1);
            c2 = temp[2].map((r)=>{
                return { label: r, value: r}
            });
            c3 = temp[3].map((r) => {
                return { label: r, value: r }
            });
        }
        if (select.length === 0){   
            m2.PASS_FLAG = ''
        }

        let radio = [ {value:'1',text:'มี'}, {value:'',text:'ไม่มี/ไม่พบ'},]
        return <div>
                        <form >
                            <table>
                                <tr>
                                    <td>สถานะหลักฐานที่ตรวจพบ</td>
                                    <td>
                                      <RadioGroup onChange={(e)=>{
                                            console.log(e)
                                            let { m2 } =  this.state;
                                            m2.EVIDENCE_FLAG = e.target.value
                                m2.PASS_FLAG = ''
                                m2.EXTRA_ARRAY = [];
                                            this.setState({m2:m2})
                                        }} value={m2.EVIDENCE_FLAG}>
                                        {
                                            radio.map((r)=>{
                                                return <Radio value={r.value}>{r.text}</Radio>
                                            })
                                        }
                                    </RadioGroup>
                                    </td>
                                </tr>				
                                <tr>
                                    <td>หลักฐานที่ตรวจพบ</td><td>
                                      <Input  name="EVIDENCE_DESC" value={m2.EVIDENCE_DESC} size="80" maxlength="500"
                                      onChange={(e)=>{
                                            console.log(e)
                                            let { m2 } =  this.state;
                                            m2.EVIDENCE_DESC = e.target.value
                                            
                                            this.setState({m2:m2})
                                        }}
                                       style={{width: '100%'}}/>
                                    </td>
                                </tr>
                                <tr>
                                    <td>ความครบถ้วนถูกต้อง</td><td>
                                        <Select name="PASS_FLAG" className="" onChange={(e)=>{
                                             console.log(e)
                                            let { m2 } =  this.state;
                                            m2.PASS_FLAG = e
                                            m2.EXTRA_ARRAY = [];
                                            this.setState({m2:m2})
                                        }}   value={m2.PASS_FLAG}>
                                        <Option value="">กรุณาเลือก</Option>
                                        {
                                            select.filter(r=>{
                                                if (m2.EVIDENCE_FLAG !== ''){
                                                    return true;
                                                }else if (m2.EVIDENCE_FLAG === '' && r.value !=='1'){
                                                  return true;
                                                }else{
                                                  return false;
                                                }
                                            }).map((r)=>{
                                                return <Option value={r.value}>{r.text}</Option>
                                            })
                                        }
                                        </Select>

                                    </td>
                                </tr>
                    <tr style={{
                        display: (m2.PASS_FLAG === '2' && c2.length > 0) || (m2.PASS_FLAG === '3' && c3.length > 0)  ? 'contents' : 'none'}}>
                                    <td> &nbsp;</td>
                                    <td>

                                        {
                                            m2.PASS_FLAG ==='2'?
                                            <div>
                                                <CheckboxGroup options={c2} value={m2.EXTRA_ARRAY} onChange={(e)=>{
                                                        let { m2 } = this.state;
                                                        m2.EXTRA_ARRAY = e;
                                                        this.setState({ m2: m2 })
                                                }} />
                                            </div>:null
                                        }
                                        {
                                            m2.PASS_FLAG === '3' ? 
                                            <div>
                                                <CheckboxGroup options={c3} value={m2.EXTRA_ARRAY} onChange={(e) => {
                                                    let { m2 } = this.state;
                                                    m2.EXTRA_ARRAY = e;
                                                    this.setState({ m2: m2 })

                                                }} />
                                            </div> : null
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td>ข้อคิดเห็นการปรับปรุงวิธีการดำเนินการจัดการพลังงาน</td>
                                    <td>
                                     <TextArea  name="NOTE" value={m2.NOTE} size="80" maxlength="500"
                                      onChange={(e)=>{
                                            console.log(e)
                                            let { m2 } =  this.state;
                                            m2.NOTE = e.target.value
                                            this.setState({m2:m2})
                                        }}
                                       style={{width: '100%'}}/>
                                    </td>
                                </tr>
                                <tr>
                                    {/* <td colSpan='2' align='right'>
                &nbsp;
                                    </td> */}
                                </tr>
                            </table>
                           
                        </form>
                    </div>
    }
  render() {
     let {modeLayout1 ,modeLayout2 ,modeLayout3 ,modeLayout4 } = this.state

    return <div>
                <div className='myForm-2' style={{minHeight:'530px'}}>
                    {/* {this.MDLayout2()} */}
                    {this.Layout1()}
                    {this.Layout2()}
                    {this.Layout3()}
                </div>
          </div>;
  }
}

export default Xpage6ef04dc09;



// WEBPACK FOOTER //
// ./src/view/main/xpage6/ef04dc09.js